module.exports = __webpack_public_path__ + "static/img/web3.ebd1e6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/develop/soft/web3.jpg
// module id = h8tA
// module chunks = 0